import { Component, type ReactNode } from "react";

interface Props { children: ReactNode }
interface State { error: Error | null }

export class AppErrorBoundary extends Component<Props, State> {
  override state: State = { error: null };
  static getDerivedStateFromError(error: Error): State { return { error }; }
  override componentDidCatch(): void {
    // Raw patient text and error payloads are intentionally not written to the console or telemetry.
  }
  override render() {
    if (this.state.error !== null) {
      return <main id="main-content" className="patient-main"><h1 tabIndex={-1}>The service could not show this page</h1><p>Your entered information has been preserved on the server where it was already saved.</p><p>Emergency contact information remains available.</p><a className="emergency-action" href="/emergency-shell/index.html">Get emergency help</a><p><button className="button button-primary" type="button" onClick={() => location.reload()}>Try this page again</button></p></main>;
    }
    return this.props.children;
  }
}
